module.exports = __webpack_public_path__ + "img/bg_noticia.9eb2599c.png";